import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              视频分类
            </h2>
            <p className="text-sm text-foreground-500 mt-1">按类别浏览你感兴趣的内容</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">{cat.count}+ 部</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}